export default "__VITE_ASSET__BThtbfUv__"